module.exports = __webpack_public_path__ + "static/media/fortlev-solar-usina-08.0094b28d.png";